export default {
  state: {
    priority: {
      show: false,
      success: false
    }
  },
  mutations: {
    setShowGeofencePriority (state, value) { state.priority.show = value },
    setPrioritySuccess (state, value) { state.priority.success = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/geofences/geofence-priority.js